module.exports = {"654201001":"和平街道","654201002":"杜别克街道","654201003":"新城街道","654201100":"二工镇","654201101":"恰夏镇","654201102":"博孜达克镇","654201200":"喀拉哈巴克乡","654201202":"阿西尔达斡尔民族乡","654201203":"阿不都拉乡","654201204":"也门勒乡","654201502":"兵团第九师一六二团","654201503":"兵团农九师一六三团","654201504":"兵团农九师一六四团","654201512":"巴克图经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654201.json
// module id = 3278
// module chunks = 0